import React, { useMemo, useState } from 'react';
import { OutlinedInput } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import StyledFieldContainer from '../helpers/StyledFieldContainer';
import SearchLocation from '../../../SearchLocation/SearchLocation';
import CustomAutocomplete from '../../../Form/CustomAutocomplete';
import RadioButton from '../../../Form/RadioButton/RadioButton';
import { getValuesByKey } from '../../../../../utils/helpers';
import classes from './JobAlertForm.module.scss';

export default function JobAlertForm(props) {
  const { title, initialData, confirmHandler } = props;

  const { t } = useTranslation();

  const functionsDirections = useSelector((state) => state.constFromApi.functionsDirections);
  const industries = useSelector((state) => state.constFromApi.industries);
  const contractTypes = useSelector((state) => state.constFromApi.contractTypes);

  const initFunctions = useMemo(
    () => getValuesByKey(initialData.JobAlertJobFunctions || [], 'JobFunctionId', functionsDirections, 'JobFunctionId'),
    [initialData.JobAlertJobFunctions]
  );
  const initIndustries = useMemo(
    () => getValuesByKey(initialData.JobAlertIndustries || [], 'IndustryId', industries, 'IndustryId'),
    [initialData.JobAlertIndustries]
  );
  const initContractTypes = useMemo(
    () => getValuesByKey(initialData.JobAlertContractTypes || [], 'JobType', contractTypes, 'label'),
    [initialData.JobAlertContractTypes]
  );

  const [keywords, setKeywords] = useState(initialData.Keyword || '');
  const [location, setLocation] = useState(initialData.Location || '');
  const [functions, setFunctions] = useState(initFunctions || []);
  const [selectedIndustries, setSelectedIndustries] = useState(initIndustries || []);
  const [contracts, setContracts] = useState(initContractTypes || []);
  const [freq, setFreq] = useState(initialData.Frequency || 'daily');

  const sendData = () => {
    const prepearedData = {
      UserId: localStorage.getItem('UserId'),
      Keyword: keywords,
      JobAlertIndustries: selectedIndustries.map((industry) => ({ IndustryId: industry.IndustryId })),
      JobAlertJobFunctions: functions.map((functionItem) => ({ JobFunctionId: functionItem.JobFunctionId })),
      JobAlertContractTypes: contracts.map((type) => ({ JobType: type.label })),
      Frequency: freq,
      Location: location,
      IsActive: true,
      Id: initialData.Id
    };

    confirmHandler(prepearedData);
  };

  return (
    <section className={classes.mainWrapper}>
      <div className={classes.header}>
        <p>{title}</p>
      </div>
      <hr />
      <div className={classes.body}>
        <div className={classes.textFieldsWrapper}>
          <StyledFieldContainer>
            <SearchIcon sx={{ marginRight: '8px', color: '#d1d3d4' }} />
            <OutlinedInput
              placeholder={t('dashboard.filter.search')}
              sx={{
                width: '100%',
                height: '100%',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none'
                }
              }}
              value={keywords}
              onChange={(e) => setKeywords(e.target.value)}
            />
          </StyledFieldContainer>
          <StyledFieldContainer>
            <LocationOnIcon sx={{ marginRight: '8px', color: '#d1d3d4' }} />
            <SearchLocation
              value={location}
              changeHandler={setLocation}
              withClear={false}
              placeholder={t('dashboard.filter.select_location')}
            />
          </StyledFieldContainer>
        </div>
        <p className={classes.label}>{t('alerts.modal.function.label')}</p>
        <CustomAutocomplete
          options={functionsDirections}
          value={functions}
          onChange={(type) => setFunctions(type)}
          placeholder={t('alerts.modal.function.placeholder')}
        />
        <p className={classes.label}>{t('alerts.modal.industry.label')}</p>
        <CustomAutocomplete
          options={industries}
          value={selectedIndustries}
          onChange={(type) => setSelectedIndustries(type)}
          placeholder={t('alerts.modal.industry.placeholder')}
        />
        <p className={classes.label}>{t('alerts.modal.contract_type.label')}</p>
        <CustomAutocomplete
          options={contractTypes}
          value={contracts}
          onChange={(type) => setContracts(type)}
          placeholder={t('alerts.modal.contract_type.placeholder')}
        />
        <p className={classes.label}>{t('alerts.modal.frequency.label')}</p>
        <div className={classes.frequency}>
          <RadioButton label="Daily" checked={freq === 'daily'} onChange={() => setFreq('daily')} />
          <RadioButton label="Weekly" checked={freq === 'weekly'} onChange={() => setFreq('weekly')} />
        </div>
      </div>
      <hr />
      <div className={classes.footer}>
        <button
          className={`button ${classes.btn} ${
            !keywords && !location && !functions.length && !selectedIndustries.length && !contracts.length
              ? classes.disabled
              : ''
          }`}
          onClick={sendData}
          disabled={!keywords && !location && !functions.length && !selectedIndustries.length && !contracts.length}
        >
          <span className="d-inline text-capitalize">Save Alert</span>
        </button>
      </div>
    </section>
  );
}
